import { EParakstsBox } from '../../../../../../components/EParakstsBox/EParakstsBox';
import { Box } from '@mui/material';
import { BackToServiceProviderLink } from '../../../BackToServiceProviderLink/BackToServiceProviderLink';
import { AuthErrorResponseCode } from '../../../../../../common/types/auth-error-response';

interface EpsTabPanelProps {
  canStart: boolean;
  socketErrorCode: string;
  setSocketErrorCode: (code: string) => void;
  epsBoxRef: React.RefObject<HTMLDivElement | null>;
}

export const EpsTabPanel = ({ canStart, socketErrorCode, setSocketErrorCode, epsBoxRef }: EpsTabPanelProps) => (
  <>
    <EParakstsBox
      ref={epsBoxRef}
      canStart={canStart}
      socketErrorCode={socketErrorCode}
      setSocketErrorCode={setSocketErrorCode}
    />
    <Box
      sx={{
        mt: '1.5rem',
        textAlign: 'center'
      }}>
      <BackToServiceProviderLink errorCode={AuthErrorResponseCode.USER_CANCEL} />
    </Box>
  </>
);
